export default __webpack_public_path__ + "static/before1-88509a2400cc2c1221316648442fe442.jpg";